module.exports = __webpack_public_path__ + "img/horizontal_3_5_8023.1027a7b9.png";